import './src/styles/global.css'

export const shouldUpdateScroll = () => {
  return false
}
